// import store from "@/state/store";

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/account/login"),
        meta: {
            title: "Login",
            // beforeResolve(routeTo, routeFrom, next) {
            //     if (store.getters["auth/loggedIn"]) {
            //         next({name: "dashboard"});
            //     } else {
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/esqueceu-senha",
        name: "forgot-password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Recuperar Senha",
        },
    },
    {
        path: "/recuperar-senha",
        name: "change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Resetar Senha",
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("@/views/account/logout"),
        meta: {
            title: "Logout",
        },
    },
    {
        path: "/",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("@/views/dashboard/index"),
    },

    {
        path: "/meu-perfil",
        name: "my-profile",
        meta: {
            title: "Meu Perfil",
            authRequired: true,
        },
        component: () => import("@/views/profile/my-profile.vue"),
    },

    {
        path: "/usuarios",
        name: "users",
        meta: {
            title: "Usuários",
            authRequired: true,
        },
        component: () => import("@/views/management/users.vue"),
    },

    {
        path: "/configuracoes",
        name: "configurations",
        meta: {
            title: "Configurações",
            authRequired: true,
        },
        component: () => import("@/views/management/configurations.vue"),
    },

    {
        path: "/unidades",
        name: "branches",
        meta: {
            title: "Unidades",
            authRequired: true,
        },
        component: () => import("@/views/management/branches.vue"),
    },

    {
        path: "/salas",
        name: "rooms",
        meta: {
            title: "Salas",
            authRequired: true,
        },
        component: () => import("@/views/management/rooms.vue"),
    },

    {
        path: "/especialidades",
        name: "specialties",
        meta: {
            title: "Especialidades",
            authRequired: true,
        },
        component: () => import("@/views/management/specialties.vue"),
    },

    {
        path: "/cids",
        name: "cids",
        meta: {
            title: "CID's",
            authRequired: true,
        },
        component: () => import("@/views/management/cids.vue"),
    },

    {
        path: "/planos-de-saude",
        name: "health-plans",
        meta: {
            title: "Planos de Saúde",
            authRequired: true,
        },
        component: () => import("@/views/management/health-plans.vue"),
    },

    {
        path: "/administrativo",
        name: "administrative",
        meta: {
            title: "Administrativo",
            authRequired: true,
        },
        component: () => import("@/views/management/index.vue"),
    },

    {
        path: "/agendamento",
        name: "scheduling",
        meta: {
            title: "Agendamento",
            authRequired: true,
        },
        component: () => import("@/views/schedule/schedule.vue"),
    },

    {
        path: "/profissionais",
        name: "professionals",
        meta: {
            title: "Profissionais",
            authRequired: true,
        },
        component: () => import("@/views/professionals/index.vue"),
    },

    {
        path: "/profissionais/:id/diario",
        name: "professionals-diary",
        meta: {
            title: "Diários do Profissional",
            authRequired: true,
        },
        component: () => import("@/views/professionals/diary.vue"),
    },

    {
        path: "/profissionais/:id/disponibilidade",
        name: "professionals-availability",
        meta: {
            title: "Disponibilidade do Profissional",
            authRequired: true,
        },
        component: () => import("@/views/professionals/schedule-availability.vue"),
    },

    {
        path: "/profissionais/:id",
        name: "professionals-schedule",
        meta: {
            title: "Agenda do Profissional",
            authRequired: true,
        },
        component: () => import("@/views/professionals/schedule.vue"),
    },

    {
        path: "/pacientes",
        name: "patients",
        meta: {
            title: "Pacientes",
            authRequired: true,
        },
        component: () => import("@/views/patients/index.vue"),
    },

    {
        path: "/pacientes/:id/diario",
        name: "patients-diary",
        meta: {
            title: "Diários do Paciente",
            authRequired: true,
        },
        component: () => import("@/views/patients/diary.vue"),
    },

    {
        path: "/pacientes/:id",
        name: "patients-details",
        meta: {
            title: "Detalhes do Paciente",
            authRequired: true,
        },
        component: () => import("@/views/patients/details.vue"),
    },

    {
        path: "/pacientes/agenda/:id",
        name: "pacientes-schedule",
        meta: {
            title: "Agenda do Profissional",
            authRequired: true,
        },
        component: () => import("@/views/patients/schedule.vue"),
    },

    {
        path: "/agenda",
        name: "schedule",
        meta: {
            title: "Agenda Base",
            authRequired: true,
        },
        component: () => import("@/views/schedule/index.vue"),
    },

    {
        path: "/agenda-diaria",
        name: "daily-schedule",
        meta: {
            title: "Agenda Diária",
            authRequired: true,
        },
        component: () => import("@/views/schedule/daily-schedule.vue"),
    },

    {
        path: "/entradas",
        name: "income",
        meta: {
            title: "Entradas",
            authRequired: true,
        },
        component: () => import("@/views/financial/incomes.vue"),
    },

    {
        path: "/saidas",
        name: "expense",
        meta: {
            title: "Saídas",
            authRequired: true,
        },
        component: () => import("@/views/financial/expenses.vue"),
    },

    {
        path: "/chat",
        name: "chat",
        meta: {
            title: "Chat",
            authRequired: true,
        },
        component: () => import("@/views/chat/index.vue"),
    },

    {
        path: "/fundos-de-reserva",
        name: "reserve-funds",
        meta: {
            title: "Fundos de Reserva",
            authRequired: true,
        },
        component: () => import("@/views/financial/reserve-funds.vue"),
    },

    {
        path: "/atendimentos",
        name: "attendances",
        meta: {
            title: "Atendimentos",
            authRequired: true,
        },
        component: () => import("@/views/attendances/index.vue"),
    },

    {
        path: "/transacoes",
        name: "transactions",
        meta: {
            title: "Transações",
            authRequired: true,
        },
        component: () => import("@/views/transactions/index.vue"),
    },
];

